<script setup lang="ts">

</script>
<template>
  <div class="dyh-container">
    <section class="banner-container w-1062">
      <CySkeletonLine height="320"></CySkeletonLine>
    </section>
    <section class="main-wrap w-1062">
      <div class="main-position">
        <CySkeletonLine height="352" width="250"></CySkeletonLine>
      </div>
      <div class="main-position">
        <CySkeletonLine height="352" width="250"></CySkeletonLine>
      </div>
      <div class="main-position">
        <CySkeletonLine height="352" width="250"></CySkeletonLine>
      </div>
      <div class="main-position">
        <CySkeletonLine height="352" width="250"></CySkeletonLine>
      </div>
    </section>
    <section class="ranking-container w-1062">
      
      <div class="ranking-item-wrap" v-for="item in [1,2,3,4,5,6,7,8]">
          <div class="ranking-image"><CySkeletonLine height="352" width="250"></CySkeletonLine></div>
          <div class="ranking-info">
            <div class="title"><CySkeletonLine height="40" width="200"></CySkeletonLine></div>
            <div class="venue"><CySkeletonLine height="36" width="200"></CySkeletonLine></div>
            <div class="price"><CySkeletonLine height="18" width="200"></CySkeletonLine></div>
          </div>
      </div>
    </section>
  </div>
</template>
<style lang="less" scoped>
.dyh-container {
  min-height: calc(100vh - 200px);
}
.banner-container {
  position: relative;
  margin-top: -1px;
  margin-bottom: 60px;
  .dyh-cutdown-wrapper {
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 450px;
    padding: 15px 32px;
    background: rgba(0, 0, 0, 0.24);
    z-index: 999;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    box-sizing: border-box;
    .btn-register {
      width: 128px;
      height: 48px;
      cursor: pointer;
      background: #A9823E;
    }
  }
}

.dyh-container {
  min-height: calc(100vh - 200px);
  padding-top: 20px;
  background-color: #ECECEA;
}
:deep(.swiper-button-disabled) {
  pointer-events: initial !important;
}
.banner-container {
  position: relative;
  margin-bottom: 60px;
  .dyh-cutdown-wrapper {
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 450px;
    padding: 15px 32px;
    background: rgba(0, 0, 0, 0.24);
    z-index: 999;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    box-sizing: border-box;
    .btn-register {
      width: fit-content;
      height: 48px;
      padding: 0 12px;
      cursor: pointer;
      background: #A9823E;
    }
  }
}


/**  20240913 tiaoqiao_web_vue_vite  */
.main-wrap{
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  .main-position{
    width: 250px;
    height: 352px;
    img{
      height: 100%;
      width: 100%;
    }
    .text{
      position: absolute;
      top: 20px;
      left: 20px;
      color: #fff;
      font-size: 14px;
    }
  }
}
.ranking-container{
  display: flex;
  justify-content:flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 60px;
  .ranking-item-wrap{
    width: 250px;
    background-color: #fff;
    margin-bottom: 20px;
    &.blank{
      opacity: 0;
    }
    .ranking-image{
      width: 250px;
      height: 352px;
      background-color: #fff;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .ranking-info{
      padding: 16px 12px;
      
      .title {
        font-size: 16px;
        color: rgba(0,0,0,0.898);
        line-height: 20px;
        height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 12px;
      }
      .venue {
        font-size: 14px;
        color: #999999;
        line-height: 18px;
        height: 36px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 6px;
      }
      .date {
        font-size: 14px;
        color: #999999;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 12px;
      }
      .price {
        font-size: 14px;
        color: #999999;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        .money{
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          font-size: 24px;
          color: #A9823E;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 1px;
          margin-right: 2px;
        }
        .unit{
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          font-size: 14px;
          color: #A9823E;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}

.section-title {
  margin-bottom: 34px;
  font-size: 30px;
  color: #333;
  font-weight: 500;
}
.match-container.news {
  margin-bottom: 45px;
  .news-item {
    width: 340px;
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
  .link {
    display: block;
    cursor: pointer;
  }
  .time {
    text-align: left;
    font-size: 12px;
    color: #777777;
  }
  .pic {
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 220px;
      object-fit: cover;
      transition: transform 0.3s linear;
    }
  }
  .footer {
    height: 106px;
    padding: 16px;
    background: rgba(8, 139, 212, 0.1);
    box-sizing: border-box;
    .title {
      text-align: left;
      font-size: 14px;
      color: #1a1a1a;
      line-height: 20px;
      .text-ellipsis(2);
    }
    .time {
      margin-left: 1px;
    }
  }
}
.match-container.tickets {
  margin-bottom: 30px;
}
.match-container.news,
.match-container.venues {
  .limit-swiper {
    :deep(.swiper) {
      margin: 0;
    }
    :deep(.swiper-button-prev),
    :deep(.swiper-button-next) {
      display: none;
    }
  }
}
.match-container.venues {
  margin-bottom: 40px;
  &:last-of-type {
    margin-bottom: 100px;
  }
  .venues-item {
    position: relative;
    width: 340px;
    height: 220px;
    cursor: pointer;
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
  .pic {
    height: 100%;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s linear;
    }
  }
  .footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 52px;
    padding: 16px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 16px;
    .title {
      font-weight: 500;
      .text-ellipsis(1);
    }
  }
}
</style>
